angular.module('videosharing-embed').filter('whitelist', function () {
	'use strict';
    return function (options, whitelist) {
        var filteredOptions = {};
        angular.forEach(options, function (value, key) {
            if (whitelist.indexOf(key) != -1) filteredOptions[key] = value;
        });
        return filteredOptions;
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/ng-videosharing-embed/src/filters/whitelist.js
// module id = 1588
// module chunks = 1